import { Component, OnInit, Input } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { CpmService } from '../../service/cpm.service'
import { StoreService } from '../../service/store.service'
import { Subscription } from 'rxjs/Subscription'
@Component({
  selector: 'app-additional-info-foreign-exposure',
  templateUrl: './additional-info-foreign-exposure.component.html',
  styleUrls: ['./additional-info-foreign-exposure.component.scss']
})
export class AdditionalInfoForeignExposureComponent implements OnInit {
  @Input() companyProfile: any
  @Input() printPage
  @Input() isFullFactSheet
  isForeignExposure = true
  subscription: Subscription
  listInvesment = []
  listRev = []
  listTable = []
  header
  headerIn = []
  headerRev = []
  country = []
  headerNew = []
  listShow = []
  totalRev = []
  yearLast
  totalIn = []
  symbol
  compareInv
  compareRev
  round = 3
  noForeignData
  constructor(
    private cpmService: CpmService,
    private activatedRoute: ActivatedRoute,
    private store: StoreService
  ) {}

  ngOnInit() {
    const { symbol } = this.activatedRoute.snapshot.params
    if (symbol !== undefined) {
      this.onChangeData(symbol)
    }
    this.subscription = this.store
      .getSecurityProfileNewResultObservable()
      .subscribe(response => {
        if (!response) {
          return
        }
        this.symbol = response['securitySymbol']
        this.onChangeData(this.symbol)
      })
  }

  async onChangeData(symbol) {
    this.country = []
    this.headerNew = []
    this.listInvesment = []
    this.listRev = []
    this.headerIn = []
    this.headerRev = []
    this.cpmService.getForeignExposure(symbol, this.round).then(foreign => {
      this.listTable = []
      foreign.map(obj => {
        const data = {
          country: obj.countryFullName,
          investment: obj.investment,
          revenue: obj.revenue
        }
        this.listTable.push(data)
        const listCountry = obj.countryFullName
        const listIn = obj.investment
        const listRev = obj.revenue
        listIn.map(inves => {
          this.headerIn.push(inves.year)
        })
        listRev.map(rev => {
          this.headerRev.push(rev.year)
        })
        this.country.push(listCountry)
      })
      this.country = this.country.reduce(function(a, b) {
        if (a.indexOf(b) < 0) {
          a.push(b)
        }
        return a
      }, [])
      this.compareInv = 0
      this.compareRev = 0
      if (this.headerIn.length > 0 && this.headerIn !== undefined) {
        this.headerIn = this.headerIn.reduce(function(a, b) {
          if (a.indexOf(b) < 0) {
            a.push(b)
          }
          return a
        }, [])
        const maxIn = this.headerIn.reduce(function(a, b) {
          return Math.max(a, b)
        })
        if (this.compareInv !== undefined) {
          this.compareInv = maxIn
        }
      } else if (this.headerRev.length > 0 && this.headerRev !== undefined) {
        this.headerRev = this.headerRev.reduce(function(a, b) {
          if (a.indexOf(b) < 0) {
            a.push(b)
          }
          return a
        }, [])
        const maxRev = this.headerRev.reduce(function(a, b) {
          return Math.max(a, b)
        })
        if (this.compareRev !== undefined) {
          this.compareRev = maxRev
        }
      }
      if (this.compareInv === 0 && this.compareRev === 0) {
        this.noForeignData = true
      } else {
        this.noForeignData = false
      }
      this.headerNew = []
      this.compareInv > this.compareRev
        ? this.headerNew.push(this.compareInv)
        : this.headerNew.push(this.compareRev)
      this.compareInv > this.compareRev
        ? (this.yearLast = this.compareInv)
        : (this.yearLast = this.compareRev)
      // tslint:disable-next-line:max-line-length
      this.compareInv > this.compareRev
        ? this.headerNew.unshift(this.compareInv - 2, this.compareInv - 1)
        : this.headerNew.unshift(this.compareRev - 2, this.compareRev - 1)
      // console.log(this.listTable, 'listtable')
      this.listInvesment = []
      this.listRev = []
      this.listTable.map(obj => {
        this.country.map(c => {
          this.headerNew.map(year => {
            if (obj.country === c) {
              obj.investment
                .filter(invesment => invesment.year === year)
                .map(inves => {
                  const data = {
                    country: c,
                    year: year,
                    value: inves.amount
                  }
                  this.listInvesment.push(data)
                })

              obj.revenue.filter(revenue => revenue.year === year).map(rev => {
                if (rev.year === year) {
                  const data = {
                    country: c,
                    year: year,
                    value: rev.amount
                  }
                  this.listRev.push(data)
                }
              })
            }
          })
        })
      })
      this.totalIn = []
      this.totalIn = this.headerNew.map(head => {
        const list = []
        this.listInvesment
          .filter(invesment => invesment.year === head)
          .map(inves => {
            list.push(inves.value)
          })
        const total = list.reduce((a, b) => a + b, 0)
        return total
      })
      this.totalRev = []
      this.totalRev = this.headerNew.map(head => {
        const list = []
        this.listRev.filter(revenue => revenue.year === head).map(rev => {
          list.push(rev.value)
        })
        const total = list.reduce((a, b) => a + b, 0)
        return total
      })
    })
  }

  isPositivenumber(value) {
    const num = parseFloat(value)
    return num < 0 ? 'negative' : 'positive'
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/additional-info-foreign-exposure/additional-info-foreign-exposure.component.ts